import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useVisitCard from './useVisitCard';

const useSingleVisitCard = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading } = useVisitCard(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleVisitCard;
